import React, { useContext } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { RecommendationsInspireCarousel } from '@fiverr-private/inspire_listings';
import { getTranslatedSubCategoryName } from '../../../../lib/catalog/getTranslatedSubCategoryName';
import { CollectionsContext } from '../context/CollectionsContext';
import { COPIES_PREFIX } from '../constants';
import type { RecommendationsCarouselProps } from './types';

export const RecommendationsCarousel = ({ inspireDeliveryId, subCategoryId }: RecommendationsCarouselProps) => {
  const [collections, setCollections] = useContext(CollectionsContext);

  const subCategoryName = getTranslatedSubCategoryName(subCategoryId);
  const title = translate(`${COPIES_PREFIX}.sub_category_more_to_explore`, { params: { subCategoryName } });
  const relatedSubCategoryIds = [subCategoryId];
  const inspireDeliveryIdsSaved = [inspireDeliveryId];

  return (
    <RecommendationsInspireCarousel
      title={title}
      relatedSubCategoryIds={relatedSubCategoryIds}
      collections={collections || []}
      onUpdateCollections={setCollections}
      mixpanelEnabled
      mixpanelOptions={{
        pageName: 'Inspire Delivery Page',
        hostingScreen: 'Inspire Delivery Page',
        component: 'Same Subcategory Carousel',
      }}
      inspireDeliveryIdsSaved={inspireDeliveryIdsSaved}
      shouldHideSavedDeliveries
      mixpanelRecommendationsEnabled
      mixpanelRecommendationsOptions={{
        pageName: 'Inspire Delivery Page',
        carouselName: 'Same Subcategory',
      }}
      bigQueryEnabled
      bigQueryOptions={{
        pageName: 'delivery_page',
      }}
    />
  );
};
